import { ExamplePagesBeats, SEO_URL_EXAMPLE_PAGES_SUFIX } from "@authory-packages/seo-static-data";
import { ExamplesPageLayout } from "../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>Explore Portfolio Examples by Category</>}
        description={
            <>
                View Authory portfolio examples grouped by categories like journalism, marketing, research, and more. Discover how top creators
                showcase and organize their best work.
            </>
        }
        panelLinks={ExamplePagesBeats.map((occ) => ({
            url: `${APPLICATION_ROUTES.EXAMPLES}/${occ.key}${SEO_URL_EXAMPLE_PAGES_SUFIX}`,
            label: occ.occupation
        }))}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"Portfolio Examples by Category | Authory"}
        ogDescription={
            "Browse Authory portfolio examples by professional category. Get inspired by how creators across industries showcase their work samples."
        }
        embedConf={[]}
        faq={[]}
    />
);

export default ExampleJobPage;
